export enum Languages {
    English = 'en',
    Spanish = 'es',
}

export const DEFAULT_LANGUAGE: Languages = Languages.English